import Alpine from "alpinejs";

Alpine.magic("instantsearchWidgets", () => async () => {
    const module = await import("instantsearch.js/dist/instantsearch.production.min.js");
    return module.widgets;
});